import { Component, ViewChild, OnInit } from '@angular/core';
import { DialogBoxComponent } from './dialog/dialog-box.component';
import { MatTable } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { first } from 'rxjs/operators';
import { EvaluacionService } from 'app/main/services/evaluacion.service';
import { Evaluacion } from 'app/main/models/evaluacion.model';
import { Router,ActivatedRoute } from '@angular/router';
import { TipoEvaluacionService } from 'app/main/services/tipo-evaluacion.service';
import { EscenarioService } from 'app/main/services/escenario.service';
import { EstructuraJerarquicaService } from 'app/main/services/estructura-jerarquica.service';
import { UsersService } from 'app/main/services/users.service';
import { NodeSelectorDialogBoxComponent} from 'app/main/apps/estructura-jerarquica/dialog/node-selector-dialog-box.component';
import { Escenario } from 'app/main/models/escenario.model';
import {TranslateService} from '@ngx-translate/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import { TokenStorageService } from 'app/main/auth/token-storage.service';


@Component({
    selector   : 'preiniciar-evaluacion',
    templateUrl: './preiniciar-evaluacion.component.html',
    styleUrls  : ['./evaluacion.component.scss']
})
export class PreiniciarEvaluacionComponent
{
    LOCAL_DATA: Evaluacion = new Evaluacion({});
    tiposEvaluacion = [];
    estructuraJerarquicas = [];
    escenarios = [];
    nodosEstructuraJerarquica = [];
    usuarios = [];
    hoy:Date = new Date();

    constructor(public dialog: MatDialog,
                public serviceTipoEvaluacion:TipoEvaluacionService,
                public service: EvaluacionService,
                private storage: TokenStorageService,
                public serviceEscenarios:EscenarioService,
                public serviceEstructuraJerarquica:EstructuraJerarquicaService,
                public userService: UsersService,
                private _snackBar: MatSnackBar,
                public router: Router,
                public translate: TranslateService,
                private route: ActivatedRoute) {}

    ngOnInit() {
      this.serviceTipoEvaluacion.getAll(0,1000).pipe().subscribe(req => {
        this.tiposEvaluacion = req.body.map( tipo => {
          console.log(tipo);
          return {
            id: tipo.id,
            nombre: tipo.nombre
          };
        });
      });

      this.serviceEscenarios.getAll(0,1000).pipe().subscribe(req => {
        this.escenarios = req.body.map( tipo => {
          console.log(tipo);
          return {
            id: tipo.id,
            nombre: tipo.nombre
          };
        });
      });

      this.serviceEstructuraJerarquica.getAll(0,1000).pipe().subscribe(req => {
        this.estructuraJerarquicas = req.body.map( tipo => {
          console.log(tipo);
          return {
            id: tipo.id,
            nombre: tipo.nombre,
            nodos: tipo.nodos
          };
        });
      });

      this.userService.getAll(0,1000).pipe().subscribe(req => {
        this.usuarios = req.body.map( user => {
          console.log(user);
          return {
            id: user.id,
            nombre: user.nombre,
            apellido: user.apellido,
            nombreCompleto: user.nombreCompleto,
            correoElectronico: user.correoElectronico,
            tipo: user.tipo,
            active: user.active
          };
        });
      });
    }

    selectTipo():void{
      this.LOCAL_DATA.nodoEstructuraJerarquica = null;
      this.LOCAL_DATA.estructuraJerarquica = null;
      this.openDialog();
    }

    openDialog(): void {
      var user = this.storage.getUser();
      //var obj = {usuario: user};
      var obj = {usuario: user,tipoEvaluacion:this.LOCAL_DATA.tipo};
      const dialogRef = this.dialog.open(NodeSelectorDialogBoxComponent, {
        width: '100%',
        data: obj,
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {
        this.LOCAL_DATA.nodoEstructuraJerarquica = result.data.nodo;
        this.LOCAL_DATA.estructuraJerarquica = result.data.estructura;

      });
    }

    addEvaluacion(): void {

      this.service.register(this.LOCAL_DATA).pipe(first()).subscribe(
        evaluacion => {
          console.log(evaluacion);

          //this.navegateTo('/evaluacion',evaluacion.body.id);
          this.LOCAL_DATA = new Evaluacion({});
          this.openSnackBar("Se ha creado la evaluación correctamente.","Cerrar");
        },
        error => {
          console.log(error);
          //this.openSnackBar("No se pudo crear la evaluación, ocurrió un error.","Cerrar");
          if(error!=null && error.error!=null && error.error.message.indexOf('org.hibernate.exception.ConstraintViolationException') !=-1){
            this.openSnackBar("Ya existe una evaluacion con el nombre: "+this.LOCAL_DATA.nombre,"Cerrar");
          }else{
            this.openSnackBar("No se pudo copiar la evaluacion, ocurrió un error.","Cerrar");
          }
        }
      );
    }

    navegateTo(url, id): void  {
        this.router.navigate([url, id]).then( (e) => {
          if (e) {
            console.log("Navigation is successful!");
          } else {
            console.log("Navigation has failed!");
          }
        });
    }

    openSnackBar(message: string, action: string) {
      this._snackBar.open(message, action, {
        duration: 5000,
      });
    }

    esOwnersGroup(usuario):boolean{

      var esOwner:boolean = false;

      usuario.tipos.forEach(element => {
        if(element.id == 4)
          esOwner = true;
      });

      return esOwner;
    }

}
